import { takeLatest } from '@redux-saga/core/effects'
import { getBillsByCustomerEffect } from './bills.effects'
import { BillsActions } from './bills.actions'

function* getBillsByCustomerSaga() {
  yield takeLatest(BillsActions.FETCH_BILLS_BY_CUSTOMER, getBillsByCustomerEffect)
}

export const BillsWatchers = [getBillsByCustomerSaga()]
